var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import * as RenderMethods from "./RenderMethods";
import { observer } from "mobx-react";
import { getCountLinkParams, getCardDetailsParams } from "../../../../helpers";
let EventCard = class EventCard extends React.Component {
    constructor(props) {
        super(props);
        this.renderEventCardDetails = RenderMethods.renderEventCardDetails;
        this.renderMarkets = RenderMethods.renderMarkets;
        this.renderMarketsCountLink = RenderMethods.renderMarketsCountLink;
        this.getCountLinkParams = getCountLinkParams;
        this.getCardDetailsParams = getCardDetailsParams;
        this.cardTypeClass = "";
        this.buttonsHolderClass = "";
        this.componentPrefix = "ev-card";
    }
    setClasses() {
        const liveClass = this.props.event.isLive
            ? `rj-ev-list__${this.componentPrefix}--live`
            : `rj-ev-list__${this.componentPrefix}--upcoming`;
        const classNames = this.props.classNames || "";
        const isSuspended = this.props.event.isSuspended
            ? `rj-ev-list__${this.componentPrefix}--suspended`
            : "";
        const hideGameState = this.props.hideGameState
            ? `rj-ev-list__${this.componentPrefix}--game-state-hidden`
            : "";
        return `rj-ev-list__${this.componentPrefix} ${liveClass} ${this.cardTypeClass} ${classNames} ${isSuspended} ${hideGameState}`;
    }
    render() {
        return (React.createElement("div", { className: this.setClasses(), "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__inner`, "data-uat": `div-ev-list-${this.componentPrefix}-inner` },
                this.renderEventCardDetails(this.getCardDetailsParams(this.props), this.componentPrefix),
                this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix),
                this.renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix))));
    }
};
EventCard = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], EventCard);
export { EventCard };
//# sourceMappingURL=EventCard.js.map